import { makeStyles, css } from '@conexasaude/conexa-hero'
import { BREAKPOINT_SIZES } from '@/styles/mixins/breakpoint-mixin'

const useStyles = makeStyles({
  passwordCard: ({ colors, border }) => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
    min-width: 400px;
    min-height: 500px;
    padding: 32px 40px;
    border-radius: ${border.radius.xs};
    background-color: ${colors.background.white};
    box-sizing: border-box;

    @media (max-width: ${BREAKPOINT_SIZES.phone.maxWidth}) {
      min-width: 100%;
      max-width: 360px;
    }
    .password-strength__indicators {
      min-width: 300px;
    }
    svg {
      margin-right: 6px;
      fill: ${colors.neutral[300]};
    }
  `,

  LinkSupport: ({ colors }) => css`
    color: ${colors.background.white};
    margin-top: 16px;
    @media screen and (max-width: 768px) {
      margin: 32px;
    }
    &:hover {
      color: ${colors.background.white};
    }
  `,
  inputIcon: () => css`
    pointer-events: unset;
    cursor: pointer;
  `,

  rulesPasswordWrapper: ({ colors }) => css`
    margin-top: 12px;
    margin-bottom: 16px;

    li {
      display: flex;
      align-items: center;
    }

    svg {
      margin-right: 12px;
      fill: ${colors.neutral[300]};
    }
  `,
  confirmInput: () => css`
    margin-top: 8px;
  `,
  buttonArea: () => css`
    margin-top: 24px;
  `,
})

export default useStyles
